if (!customElements.get('wc-kitchen-journey')) {
  customElements.define('wc-kitchen-journey', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
      this.index = 0;
      this.classList.add('is-ready');
      this.select(0);
      this.addEventListener('click', event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(this.tabs.indexOf(tab));
        if (event.target.closest('[data-step-next]')) this.select(Math.min(5, this.index + 1), true);
        if (event.target.closest('[data-step-prev]')) this.select(Math.max(0, this.index - 1), true);
      });
      this.addEventListener('keydown', event => {
        if (!event.target.matches('[role="tab"]')) return;
        let next = this.index;
        if (['ArrowDown', 'ArrowRight'].includes(event.key)) next = (this.index + 1) % this.tabs.length;
        else if (['ArrowUp', 'ArrowLeft'].includes(event.key)) next = (this.index + this.tabs.length - 1) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.select(next, true);
      });
    }
    select(index, focus = false) {
      this.index = index;
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
      if (focus) this.tabs[index].focus({preventScroll: true});
    }
  });
}
if (!customElements.get('wc-project-journal')) {
  customElements.define('wc-project-journal', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.albums = [...this.querySelectorAll('.wc-album')];
      this.filters = [...this.querySelectorAll('[data-filter]')];
      this.more = this.querySelector('.wc-more');
      this.status = this.querySelector('.wc-gallery-status');
      this.dialog = this.querySelector('dialog');
      this.category = 'all';
      this.limit = this.albums.length;
      this.classList.add('is-ready');
      this.update();
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-filter]');
        if (filter) {
          this.category = filter.dataset.filter;
          this.limit = this.albums.length;
          this.filters.forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
          this.update();
        }
        if (event.target.closest('.wc-more')) {
          const previouslyVisible = this.albums.filter(a => !a.hidden).length;
          this.limit += 4;
          this.update();
          const visible = this.albums.filter(a => !a.hidden);
          visible[previouslyVisible]?.querySelector('[data-photo]')?.focus({preventScroll: true});
        }
        const photo = event.target.closest('[data-photo]');
        if (photo && typeof this.dialog.showModal === 'function') {
          event.preventDefault();
          this.opener = photo;
          this.photos = [...photo.closest('.wc-album').querySelectorAll('[data-photo]')];
          this.photoIndex = this.photos.indexOf(photo);
          this.showPhoto();
          this.dialog.showModal();
        }
        if (event.target.closest('[data-close]')) this.dialog.close();
        if (event.target.closest('[data-prev]')) this.movePhoto(-1);
        if (event.target.closest('[data-next]')) this.movePhoto(1);
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.opener?.focus({preventScroll: true}));
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.movePhoto(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      this.addEventListener('shopify:block:select', event => {
        const album = event.target.closest('.wc-album');
        if (album) {this.category = 'all';this.limit = this.albums.length;this.update();}
      });
    }
    update() {
      let matched = 0;
      this.albums.forEach(album => {
        const match = this.category === 'all' || album.dataset.category === this.category;
        album.hidden = !match || ++matched > this.limit;
      });
      this.more.hidden = matched <= this.limit;
      this.status.textContent = this.dataset.shownTemplate.replace('[count]', Math.min(matched, this.limit));
    }
    showPhoto() {
      const link = this.photos[this.photoIndex];
      const img = this.dialog.querySelector('[data-lightbox-image]');
      img.src = link.href;
      img.alt = link.querySelector('img').alt;
      this.dialog.querySelector('[data-lightbox-title]').textContent = link.dataset.title;
      this.dialog.querySelector('[data-lightbox-count]').textContent = this.dataset.countTemplate.replace('[current]', this.photoIndex + 1).replace('[total]', this.photos.length);
      this.dialog.querySelector('[data-prev]').disabled = this.photos.length < 2;
      this.dialog.querySelector('[data-next]').disabled = this.photos.length < 2;
    }
    movePhoto(direction) {
      this.photoIndex = (this.photoIndex + direction + this.photos.length) % this.photos.length;
      this.showPhoto();
    }
  });
}
